import { RouterProvider } from 'react-router-dom';
import './styles/index.scss';
import ThemeProvider from './styles/theme';
import router from './router';
import { UserAuthContextProvider } from './context/auth_context';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <ThemeProvider>
      <UserAuthContextProvider>
        <RouterProvider router={router} />
      </UserAuthContextProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ThemeProvider>
  );
}

export default App;
